/**
 * A date as "April 2, 2027". Pinned to UTC so the day is the same wherever the reader is:
 * an expiry just after midnight UTC would otherwise read as the day before in the Americas.
 */
export function formatUntil(ms: number): string {
  return new Date(ms).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}
